export default [
  {
    title: '素材ID',
    key: 'imageId',
    width: 62
  },
  {
    title: '素材名称',
    key: 'imageName',
    width: 160
  },
  {
    title: '素材上传时间',
    key: 'imageCreateTime',
    width: 110
  },
  {
    title: '媒体名称',
    key: 'mediaName'
  },
  {
    title: '30天实际消耗',
    key: 'thirtyDaysAmount',
    width: 150
  },
  {
    title: '创建人',
    key: 'opName'
  },
  {
    title: '更新人',
    key: 'upOpName'
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 110
  },
  {
    title: '操作',
    key: 'control',
    width: 40
  }
]
